module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {

 if (typeof heading === 'string') { ;
__p += '\n<h3 class="' +
((__t = ( styles.heading )) == null ? '' : __t) +
'">' +
((__t = ( heading )) == null ? '' : __t) +
'</h3>\n';
 } ;
__p += '\n';
 if (typeof subheading === 'string') { ;
__p += '\n<p class="' +
((__t = ( styles.subheading )) == null ? '' : __t) +
'">' +
((__t = ( subheading )) == null ? '' : __t) +
'</p>\n';
 } ;
__p += '\n';

}
return __p
}